export default __webpack_public_path__ + "df050e1e1984195e71970813f3ba95e6.png";